<template>
    <div class="Servicemain-style">

        <div class="Servicemain-business">
            <div class="service-main">
             <div class="main-content">
                 <div class="content-info">
                  <div class="info-content">

                    <img src="@/assets/image/servicemain/Mapmodel.png" alt="">
                    <span>海量数据模型</span>
                  </div>
                 </div>
                 <div class="content-info">
                 
                        <img src="@/assets/image/servicemain/secure.png" alt="">
                        <span>完备标签体系</span>
                  
    
                 </div>
                 <div class="content-info">
                   
                        <img src="@/assets/image/servicemain/brainpower.png" alt="">
                        <span>链上态势感知</span>
                 
                 
                 </div>
                 <div class="content-info">
                  <div class="info-content">
                    <img src="@/assets/image/servicemain/construction.png" alt="">
                    <span>数据指标分析</span>
</div>
               
       
                 </div>
             </div>
            </div>
            <div class="service-bottom">
    <h3>服务行业/机构</h3>
    <div class="bottom-main">
      <div class="bottom-maincontent">

        <div class="bottom-content">
           <svg xmlns="http://www.w3.org/2000/svg" width="73" height="60" viewBox="0 0 73 60" fill="none">
     <g clip-path="url(#clip0_272_194)">
       <path d="M2.18682 17.3164C1.82786 17.3192 1.48078 17.4448 1.20387 17.6721C0.980475 17.9389 0.801758 18.2501 0.801758 18.6058V57.8642C0.801758 58.5755 1.42727 59.1535 2.18682 59.1535H21.0862C21.3989 59.1535 21.7564 59.0201 22.0245 58.7978C22.2925 58.5311 22.4266 58.2199 22.4266 57.8642V18.6058C22.4266 17.8944 21.8011 17.3164 21.0862 17.3164H2.18682Z" fill="#A7DBF4"/>
       <path d="M69.7424 59.1223C70.0552 59.1223 70.4126 58.9889 70.6807 58.7666C70.9488 58.4998 71.0828 58.1886 71.0828 57.8329V18.5745C71.0828 18.2188 70.9488 17.9076 70.6807 17.6408C70.4168 17.4211 70.0864 17.2959 69.7424 17.2852H50.8431C50.4841 17.2879 50.137 17.4135 49.8601 17.6408C49.6367 17.9076 49.458 18.2188 49.458 18.5745V57.8329C49.458 58.5443 50.0835 59.1223 50.8431 59.1223H69.7424Z" fill="#05ABFA"/>
       <path d="M36.085 1.42578V32.0589H41.2678V37.0829H36.085V40.373H41.2678V45.397H36.085V59.1352H45.4676C45.8251 59.1352 46.1378 59.0018 46.4059 58.7795C46.6474 58.5082 46.7891 58.1633 46.808 57.8014V2.75959C46.808 2.40584 46.6668 2.06658 46.4154 1.81644C46.164 1.56631 45.8231 1.42578 45.4676 1.42578H36.085Z" fill="#A7DBF4"/>
       <path d="M26.4888 1.42578C25.7293 1.42578 25.1484 2.00376 25.1484 2.75959V57.8014C25.1484 58.5572 25.7739 59.1352 26.4888 59.1352H36.0949V45.397H30.6887V40.373H36.0949V37.0829H30.6887V32.0589H36.0949V1.42578H26.4888Z" fill="#05ABFA"/>
     </g>
     <defs>
       <clipPath id="clip0_272_194">
         <rect width="71.44" height="59.28" fill="white" transform="translate(0.779785 0.359375)"/>
       </clipPath>
     </defs>
   </svg>
   <span>监管机构</span>
        </div>
        <div class="bottom-content">
        <svg xmlns="http://www.w3.org/2000/svg" width="77" height="76" viewBox="0 0 77 76" fill="none">
  <g clip-path="url(#clip0_277_245)">
    <path d="M11.3115 48.8867V72.2396C11.3115 74.3087 13.0044 76.0016 15.0716 76.0016H61.9275C63.3335 76.0016 64.5495 75.2112 65.1955 74.0617C65.5138 73.5075 65.6833 72.8805 65.6876 72.2415V48.8848H11.3115V48.8867Z" fill="#A7DBF4"/>
    <path d="M65.6895 48.6624V9.05307C65.6865 8.05675 65.2894 7.1021 64.5849 6.3976C63.8804 5.69309 62.9257 5.29598 61.9294 5.29297H15.0735C13.6675 5.29297 12.4515 6.08337 11.8055 7.23287C11.4858 7.78649 11.3156 8.41376 11.3115 9.05307V48.8866H65.6895V48.6624ZM44.8617 32.159V43.9409H32.1412V32.159H22.6013L38.5005 17.4321L54.4016 32.159H44.8617Z" fill="#05ABFA"/>
    <path d="M17.7026 62.5552L30.2901 69.1558V65.9581L21.7952 61.5786L30.2901 57.1763V53.9824L17.7026 60.583V62.5552ZM34.0597 69.4446H37.1225L42.6496 52.0273H39.5621L34.0597 69.4446ZM46.7099 53.9824V57.1782L55.2257 61.5786L46.7099 65.9581V69.1558L59.2974 62.5552V60.583L46.7099 53.9824Z" fill="#EFF2F4"/>
  </g>
  <defs>
    <clipPath id="clip0_277_245">
      <rect width="76" height="76" fill="white" transform="translate(0.5)"/>
    </clipPath>
  </defs>
</svg>
<span>开发者</span>
     </div>
      </div>
      <div class="bottom-maincontent">

        <div class="bottom-content">
   <svg xmlns="http://www.w3.org/2000/svg" width="77" height="76" viewBox="0 0 77 76" fill="none">
<path d="M45.0058 59.0678C44.4648 59.6556 44.1704 60.4288 44.1832 61.2275C44.1961 62.0263 44.5154 62.7896 45.0751 63.3596C45.3561 63.6518 45.6922 63.8854 46.064 64.0471C46.4358 64.2089 46.8358 64.2954 47.2412 64.3019C47.6466 64.3083 48.0492 64.2345 48.4259 64.0846C48.8026 63.9348 49.146 63.7119 49.4362 63.4289L68.6114 44.1153C69.1563 43.5194 69.4504 42.7363 69.4324 41.929C69.4144 41.1217 69.0857 40.3525 68.5147 39.7815C67.9438 39.2105 67.1745 38.8818 66.3672 38.8638C65.5599 38.8458 64.7768 39.1399 64.181 39.6849L36.2144 11.926C36.4971 11.6426 36.7201 11.3054 36.8701 10.9342C37.0201 10.5631 37.0941 10.1656 37.0877 9.76536C37.0812 9.3651 36.9945 8.97022 36.8326 8.60411C36.6706 8.238 36.4369 7.90813 36.1451 7.63404C35.864 7.34188 35.5279 7.10822 35.1562 6.94651C34.7844 6.78479 34.3843 6.69823 33.979 6.69179C33.5736 6.68536 33.171 6.75918 32.7942 6.90901C32.4175 7.05885 32.0742 7.28172 31.784 7.56481L22.1618 17.2562L12.6088 26.8784C12.0679 27.4799 11.7744 28.2637 11.7872 29.0726C11.8 29.8814 12.1183 30.6555 12.6781 31.2395C12.9591 31.5317 13.2952 31.7654 13.667 31.9271C14.0388 32.0888 14.4388 32.1753 14.8442 32.1818C15.2496 32.1882 15.6522 32.1144 16.0289 31.9646C16.4056 31.8147 16.749 31.5919 17.0392 31.3088L28.8766 43.0077L8.31691 63.8442C7.87995 64.2207 7.55746 64.7122 7.38613 65.2629C7.2148 65.8137 7.20151 66.4014 7.34779 66.9593C7.49018 67.5092 7.77709 68.011 8.17876 68.4127C8.58043 68.8144 9.08224 69.1013 9.63215 69.2437C10.1968 69.3617 10.7827 69.3277 11.33 69.1453C11.8773 68.9629 12.3663 68.6385 12.7473 68.2053L33.3069 47.3688L45.0058 59.0678Z" fill="#05ABFA"/>
</svg>
<span>执法机构</span>
</div>
<div class="bottom-content">
        <svg xmlns="http://www.w3.org/2000/svg" width="77" height="76" viewBox="0 0 77 76" fill="none">
  <path d="M46.5077 28.7187L44.9877 25.5837L64.3677 16.1787L65.8877 19.3137L46.5077 28.7187ZM24.1827 52.6587L28.1252 41.2112L31.4027 42.3512L27.4602 53.7987L24.1827 52.6587ZM14.4927 16.7487L16.9152 14.3262L27.3177 24.6812L24.8477 27.1512L14.4927 16.7487Z" fill="#A7DBF4"/>
  <path d="M64.0542 24.2021C60.2542 24.2021 57.1667 21.0671 57.1667 17.2671C57.1667 13.4671 60.2542 10.3796 64.0542 10.3796C67.9017 10.3796 70.9892 13.4671 70.9892 17.2671C70.9892 21.0671 67.9017 24.2021 64.0542 24.2021ZM23.4892 69.0896C20.9697 69.0896 18.5533 68.0887 16.7717 66.3071C14.9901 64.5255 13.9892 62.1092 13.9892 59.5896C13.9892 57.0701 14.9901 54.6537 16.7717 52.8721C18.5533 51.0905 20.9697 50.0896 23.4892 50.0896C26.0088 50.0896 28.4252 51.0905 30.2068 52.8721C31.9883 54.6537 32.9892 57.0701 32.9892 59.5896C32.9892 62.1092 31.9883 64.5255 30.2068 66.3071C28.4252 68.0887 26.0088 69.0896 23.4892 69.0896ZM12.2317 20.7346C8.43174 20.7346 5.34424 17.6471 5.34424 13.7996C5.34424 9.99961 8.43174 6.91211 12.2317 6.91211C14.0647 6.91211 15.8226 7.64026 17.1187 8.93637C18.4148 10.2325 19.143 11.9904 19.143 13.8234C19.143 15.6563 18.4148 17.4142 17.1187 18.7104C15.8226 20.0065 14.0647 20.7346 12.2317 20.7346Z" fill="#A7DBF4"/>
  <path d="M22.6201 31.1118C22.6236 32.7 22.9398 34.2719 23.5507 35.7378C24.1616 37.2038 25.0553 38.535 26.1807 39.6556C27.3061 40.7761 28.6412 41.6641 30.1098 42.2686C31.5784 42.8732 33.1516 43.1826 34.7398 43.1792C36.3279 43.1758 37.8998 42.8596 39.3658 42.2487C40.8317 41.6377 42.163 40.7441 43.2835 39.6186C44.4041 38.4932 45.292 37.1581 45.8966 35.6896C46.5012 34.221 46.8106 32.6477 46.8071 31.0596C46.8002 27.8522 45.5194 24.7789 43.2466 22.5158C40.9737 20.2528 37.8949 18.9853 34.6875 18.9922C31.4801 18.9991 28.4068 20.2799 26.1438 22.5528C23.8807 24.8257 22.6132 27.9044 22.6201 31.1118Z" fill="#05ABFA"/>
</svg>
<span>基础设施服务商</span>
     </div>
</div>
<div class="bottom-maincontent">

  <div class="bottom-content">
        <svg xmlns="http://www.w3.org/2000/svg" width="77" height="76" viewBox="0 0 77 76" fill="none">
  <path d="M35.9131 48.6696C38.4667 47.2307 40.9088 45.6195 43.2293 43.836C44.2325 43.0659 45.2053 42.2856 46.1376 41.4749V66.1901H35.9131V48.6696ZM20.6219 66.1901V54.4963C23.9355 53.8376 27.3909 52.7331 30.8464 51.2131V66.1901H20.6219ZM5.50293 55.388H15.7275V66.1901H5.50293V55.388ZM67.2656 18.5837C67.3264 18.6445 67.3467 18.7357 67.3061 18.8168C67.2757 18.8979 67.1947 18.9485 67.1136 18.9485H58.9968C57.3147 23.3869 54.7003 27.9368 51.2651 32.2637C49.7872 34.1197 48.2038 35.8892 46.5227 37.5635C43.5644 40.5126 40.323 43.1635 36.8453 45.4776C35.224 46.5416 33.6027 47.5144 31.9712 48.3859C28.6373 50.1491 25.2731 51.4968 22.0101 52.3987C20.4293 52.8445 18.808 53.1789 17.1765 53.412C13.4981 53.9491 10.0123 53.8579 6.91146 53.1181C6.42506 53.0067 5.95893 52.8749 5.50293 52.7331V47.1192C6.57706 47.7171 7.8032 48.1325 9.18133 48.3859C10.5899 48.6291 12.0187 48.7101 13.4475 48.6189C14.6635 48.548 15.8693 48.396 17.0651 48.1528C18.4128 47.8792 19.7504 47.5144 21.0576 47.0787C23.8544 46.1363 26.7019 44.7987 29.5189 43.1064C30.9275 42.2552 32.336 41.3027 33.704 40.2893C35.8117 38.7151 37.8092 36.9985 39.6827 35.1517C40.4731 34.3512 41.2533 33.5405 42.0032 32.7096C43.4219 31.1288 44.7595 29.4669 45.9856 27.7443C48.0325 24.8563 49.7045 21.8872 50.9408 18.9485H42.4389C42.3579 18.9485 42.2768 18.8877 42.2464 18.8168C42.216 18.7357 42.2261 18.6445 42.2869 18.5837L54.5179 6.23119C54.6597 6.07919 54.8928 6.07919 55.0347 6.23119L67.2656 18.5837Z" fill="#05ABFA"/>
  <path d="M61.4745 45.7511V19.9922C59.5897 25.525 56.1039 31.2605 51.25 36.5399V48.9735C53.5401 46.8151 56.5599 45.6194 59.7012 45.6295C60.2889 45.6295 60.8868 45.6701 61.4745 45.7511Z" fill="#05ABFA"/>
  <path d="M59.7028 46.2832C66.2084 46.2832 71.498 51.5728 71.498 58.0885C71.498 64.5941 66.2084 69.8837 59.7028 69.8837C53.1871 69.8837 47.8975 64.5941 47.8975 58.0885C47.8975 51.5728 53.1871 46.2832 59.7028 46.2832ZM60.6857 60.5104V58.6864H63.9385C64.2121 58.6965 64.4655 58.5547 64.6073 58.3216C64.7492 58.0885 64.7492 57.7947 64.6073 57.5616C64.5385 57.4467 64.4402 57.3522 64.3226 57.2881C64.205 57.2239 64.0724 57.1924 63.9385 57.1968H61.2836L64.4553 52.6672C64.587 52.4505 64.6279 52.1906 64.5691 51.944C64.5103 51.6973 64.3565 51.4838 64.1412 51.3499C63.9261 51.2187 63.6677 51.1781 63.4227 51.237C63.1777 51.2958 62.966 51.4494 62.834 51.664L59.7839 56.1531H59.6116L56.5716 51.664C56.4376 51.4487 56.2242 51.2949 55.9775 51.2361C55.7309 51.1773 55.471 51.2182 55.2543 51.3499C54.8084 51.6235 54.6665 52.2112 54.9503 52.6672L58.1119 57.1968H55.4569C55.0617 57.2069 54.7375 57.5413 54.7375 57.9365C54.7375 58.3419 55.0617 58.6763 55.4569 58.6864H58.7097V60.5104H55.4569C55.2634 60.5183 55.0804 60.6007 54.9462 60.7405C54.8121 60.8803 54.7373 61.0665 54.7375 61.2603C54.7375 61.6656 55.0617 61.9899 55.4569 62.0101H58.7097V63.976C58.7097 64.5131 59.1556 64.9589 59.7028 64.9589C60.2399 64.9589 60.6857 64.5131 60.6857 63.976V62.0101H63.9385C64.2121 62.0101 64.4655 61.8784 64.6073 61.6352C64.6721 61.519 64.7061 61.3882 64.7061 61.2552C64.7061 61.1222 64.6721 60.9914 64.6073 60.8752C64.5385 60.7603 64.4402 60.6658 64.3226 60.6017C64.205 60.5375 64.0724 60.506 63.9385 60.5104H60.6857Z" fill="#A7DBF4"/>
</svg>
<span>金融机构</span>
     </div>
     <div class="bottom-content">
        <svg xmlns="http://www.w3.org/2000/svg" width="77" height="76" viewBox="0 0 77 76" fill="none">
  <g clip-path="url(#clip0_272_214)">
    <path opacity="0.5" d="M3.33064 31.3453C3.33064 25.5367 8.07521 20.7812 13.8946 20.7812C19.7141 20.7812 24.4695 25.5367 24.4695 31.3453C24.4695 37.1647 19.7141 41.9201 13.8946 41.9201C8.07521 41.9201 3.33064 37.1647 3.33064 31.3453ZM20.1266 45.7744C19.2364 48.0327 18.7044 50.5298 18.7044 53.2007V71.6035H0.833496V57.1201C0.833496 49.9327 6.70721 44.059 13.8404 44.059C16.1529 44.059 18.2266 44.7104 20.1266 45.7744Z" fill="#05ABFA"/>
    <path d="M38.7703 36.6348C43.3411 36.6348 47.4451 38.4805 50.4743 41.4988C47.4994 38.4805 43.3411 36.6348 38.7703 36.6348ZM23.1577 48.0348C23.9937 45.5376 25.3509 43.2793 27.1314 41.4988C25.2966 43.2793 23.9937 45.5376 23.1577 48.0348ZM54.448 48.0348C54.98 49.6959 55.3383 51.4222 55.3383 53.2028C55.3383 51.3571 54.98 49.6416 54.448 48.0348Z" fill="#F2F2F2"/>
    <path d="M38.7709 32.956C31.4098 32.956 25.3515 26.9629 25.3515 19.5366C25.3515 12.1103 31.3555 6.11719 38.7709 6.11719C46.1972 6.11719 52.1904 12.1103 52.1904 19.5366C52.1904 26.9629 46.1972 32.956 38.7709 32.956ZM38.4778 56.82C38.4778 62.8241 41.2138 68.1006 45.5458 71.6075H22.2681V53.2046C22.2681 51.3589 22.6264 49.6435 23.1584 48.0366C23.9944 45.5395 25.3515 43.2812 27.1321 41.5006C30.1612 38.4715 34.2652 36.6366 38.8361 36.6366C42.5709 36.6366 45.9584 37.8852 48.7486 39.9589C42.6361 43.1075 38.4778 49.4589 38.4778 56.82Z" fill="#05ABFA"/>
    <path opacity="0.5" d="M68.5173 40.7367C71.9698 39.0104 74.2824 35.4493 74.2824 31.3453C74.2824 25.5367 69.5921 20.7812 63.7076 20.7812C57.899 20.7812 53.1436 25.4715 53.1436 31.3453C53.1436 33.723 53.9144 35.8618 55.2173 37.6424C56.1076 37.523 56.9436 37.4687 57.8338 37.4687C61.8076 37.4687 65.499 38.6521 68.5173 40.7367Z" fill="#05ABFA"/>
    <path d="M62.6154 64.8214L65.5577 61.8791L74.1566 70.4888L71.2252 73.4311L62.6154 64.8214ZM55.3954 42.2168C62.4092 42.2168 68.044 47.8625 67.9897 54.8002C67.9897 61.7488 62.344 67.3945 55.3954 67.3945C48.4577 67.3945 42.812 61.7488 42.812 54.8002C42.812 47.8625 48.4577 42.2168 55.3954 42.2168ZM60.8023 51.8905L59.4994 50.8265C59.4321 50.7901 59.355 50.7758 59.279 50.7855C59.203 50.7952 59.132 50.8286 59.076 50.8808L56.2857 54.3877L55.6343 53.8557L54.2663 52.7808C54.1577 52.7265 53.9732 52.7265 53.9189 52.8459L53.4954 53.3237L52.9634 53.9751L49.9994 57.7099C49.9343 57.8294 49.9343 58.0139 50.0537 58.0682L51.4217 59.1431C51.5412 59.1974 51.7149 59.1974 51.78 59.0779L54.5703 55.5168L55.276 56.0488L56.5897 57.1237H56.644C56.7634 57.1779 56.948 57.1779 57.0023 57.0585V57.0042L60.8566 52.1294C60.9217 52.0099 60.9217 51.8362 60.8023 51.8905Z" fill="#A7DBF4"/>
  </g>
  <defs>
    <clipPath id="clip0_272_214">
      <rect width="76" height="76" fill="white" transform="translate(0.833496)"/>
    </clipPath>
  </defs>
</svg>
<span>学术研究</span>
     </div>
</div>
<div class="bottom-maincontent">
  <div class="bottom-content">
        <svg xmlns="http://www.w3.org/2000/svg" width="77" height="76" viewBox="0 0 77 76" fill="none">
  <path d="M48.0003 64.7188H15.3032C14.3584 64.7188 13.4523 64.3434 12.7842 63.6753C12.1161 63.0072 11.7407 62.1011 11.7407 61.1562V14.9061C11.7406 14.4203 11.8362 13.9392 12.0221 13.4904C12.208 13.0416 12.4804 12.6338 12.8239 12.2902C13.1674 11.9467 13.5753 11.6743 14.0241 11.4884C14.4729 11.3025 14.954 11.2069 15.4398 11.207H44.2997C44.7857 11.2067 45.2669 11.3022 45.7159 11.488C46.1649 11.6738 46.5729 11.9462 46.9166 12.2897C47.2602 12.6332 47.5328 13.0411 47.7188 13.4901C47.9047 13.939 48.0004 14.4202 48.0003 14.9061V64.7188Z" fill="#05ABFA"/>
  <path d="M61.6336 64.6284H48.0093V24.7559H61.5601C62.0407 24.7558 62.5165 24.8503 62.9605 25.0342C63.4045 25.218 63.8079 25.4875 64.1476 25.8273C64.4874 26.1671 64.757 26.5705 64.9408 27.0145C65.1246 27.4585 65.2192 27.9343 65.2191 28.4148V61.0436C65.2192 61.5145 65.1265 61.9807 64.9464 62.4157C64.7662 62.8508 64.5021 63.246 64.1691 63.5789C63.8361 63.9118 63.4408 64.1759 63.0058 64.3559C62.5707 64.536 62.1045 64.6286 61.6336 64.6284Z" fill="#7DD0F8"/>
  <path d="M19.4811 19.9941H40.2579C41.6894 19.9941 42.4051 20.4525 42.4051 21.3693V23.179C42.4051 24.0957 41.6894 24.5541 40.2579 24.5541H19.4811C18.0497 24.5541 17.334 24.0957 17.334 23.179V21.3693C17.334 20.4525 18.0497 19.9941 19.4811 19.9941Z" fill="white"/>
  <path d="M19.4811 30.8652H40.2579C41.6894 30.8652 42.4051 31.3236 42.4051 32.2404V34.0501C42.4051 34.9668 41.6894 35.4252 40.2579 35.4252H19.4811C18.0497 35.4252 17.334 34.9668 17.334 34.0501V32.2404C17.334 31.3236 18.0497 30.8652 19.4811 30.8652Z" fill="white"/>
  <path d="M19.4811 41.584H40.2579C41.6894 41.584 42.4051 42.0424 42.4051 42.9592V44.7688C42.4051 45.6856 41.6894 46.144 40.2579 46.144H19.4811C18.0497 46.144 17.334 45.6856 17.334 44.7688V42.9592C17.334 42.0424 18.0497 41.584 19.4811 41.584Z" fill="white"/>
  <path d="M59.8029 28.5859H62.2128C62.8897 28.5859 63.2281 28.9244 63.2281 29.6012V34.6904C63.2281 35.3673 62.8897 35.7057 62.2128 35.7057H59.8029C59.126 35.7057 58.7876 35.3673 58.7876 34.6904V29.6012C58.7876 28.9244 59.126 28.5859 59.8029 28.5859Z" fill="#7DD0F8"/>
  <path d="M59.8029 39.3027H62.2128C62.8897 39.3027 63.2281 39.6412 63.2281 40.318V45.4072C63.2281 46.0841 62.8897 46.4225 62.2128 46.4225H59.8029C59.126 46.4225 58.7876 46.0841 58.7876 45.4072V40.318C58.7876 39.6412 59.126 39.3027 59.8029 39.3027Z" fill="#7DD0F8"/>
</svg>
<span> 媒体机构</span>
     </div>

     <div class="bottom-content">
        <svg xmlns="http://www.w3.org/2000/svg" width="77" height="76" viewBox="0 0 77 76" fill="none">
  <path d="M71.0755 28.4746C71.9773 27.9375 71.9773 26.6404 71.0755 26.1034L39.7736 7.47829C38.9933 7.00203 38.0104 7.00203 37.22 7.47829L5.92825 26.1034C5.02639 26.6404 5.01625 27.9375 5.92825 28.4746L37.22 47.0996C38.0104 47.5658 38.9933 47.5658 39.7736 47.0996L71.0755 28.4746Z" fill="#A7DBF4"/>
  <path d="M38.4983 49.8457C39.3799 49.8457 40.2412 49.6126 40.9911 49.1667L60.8322 37.3513V54.2435C60.8322 55.0745 60.4066 55.8446 59.6972 56.2803L39.8156 68.5214C39.0455 68.9875 38.093 68.9875 37.333 68.5214L17.4514 56.2803C17.1028 56.0674 16.8151 55.7679 16.6163 55.4111C16.4174 55.0542 16.3141 54.652 16.3164 54.2435V37.4323L36.0156 49.1667C36.7672 49.6119 37.6248 49.8464 38.4983 49.8457ZM69.1516 33.5918C70.469 33.5918 71.5229 34.6659 71.5229 35.9934V46.6841C71.5229 48.0115 70.469 49.0857 69.1516 49.0857C67.8343 49.0857 66.7804 48.0014 66.7804 46.6841V35.9934C66.7804 34.6558 67.8343 33.5918 69.1516 33.5918Z" fill="#05ABFA"/>
</svg>
<span>个人研究者</span>
     </div>
</div>

   
    </div>

            </div>
        </div>
    </div>
  </template>
  
  <script setup></script>
  
  <style lang="scss" scoped>
  @media screen and (max-width: 768px) {
  }
  @media screen and (min-width: 769px) and (max-width: 1200px) {
  }
  @media screen and (min-width: 1201px) and (max-width: 2600px) {
    .Servicemain-style{
//  height: 843px;
          box-sizing: border-box;
          width: 1200px;
          margin: 0 auto;
    
        .Servicemain-business {
         
          position: relative;
      
        .service-main{
            width: 1200px;
    height: 274px;
    flex-shrink: 0;
    border-radius: 12px;
    box-sizing: border-box;
    border: 1px solid #E6E6E6;
    background: var(--web-color-text-white, #FFF);
    backdrop-filter: blur(15px);
    position:absolute;
    top: -209px;
    padding:48px;
    .main-content{
        display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    .content-info{
        display: flex;
        flex-direction: column;
        align-items: center;
    
       width: 100%;
    
    span{
        color: var(--Gray-1, #333);
    font-family: PingFang SC;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    }
    }
    .content-info:nth-child(1){
      flex: 1;
         align-items:  flex-start;
        border-right: 2px solid var(--Gray-6, #F2F2F2);
        .info-content{
          display: flex;
          flex-direction: column;
          align-items: center;
        }
    }
    .content-info:nth-child(2){
     flex: 1.4;
        border-right: 2px solid var(--Gray-6, #F2F2F2);
    }
    .content-info:nth-child(3){
      flex: 1.4;
        border-right: 2px solid var(--Gray-6, #F2F2F2);
    }
    .content-info:nth-child(4){
      flex: 1;
        align-items:  flex-end;
        .info-content{
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        // border-right: 2px solid var(--Gray-6, #F2F2F2);
    }
    }
        }
    .service-bottom{
        padding-top: 164px;
        padding-bottom: 118px;
        >h3{
            color: var(--Gray-1, #333);
text-align: center;
font-family: PingFang SC;
font-size: 40px;
font-style: normal;
font-weight: 600;
line-height: normal;
        }
        .bottom-main{
            margin-top: 80px;
            padding: 0 48px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .bottom-maincontent{
         
              .bottom-content:nth-child(2){
                margin-top: 80px;
              }
            }
            .bottom-content{
                display: flex;
                flex-direction: column;
                align-items: center;
              //  margin-right: ;
              >img{
                width: 120px;
                height: 120px;
              }
                >span{
                    margin-top: 12px;
                }
            }
            .bottom-content:nth-child(1){
             
            }
            .bottom-content:nth-child(2){
            
            }
            .bottom-content:nth-child(3){
              
            }
        }
      
    }
         
        }
    }
  }
  </style>
  